import { effect, Injectable, signal } from "@angular/core";
import { RtMessage } from "../interfaces/rt-message.interface";
import { NewBookingSignalRDTO } from "../interfaces/new-booking-signalR.interface";
import { BookingStatusUpdateSignalRDTO } from "../interfaces/booking-status-update-signalR.interface";
import { CancelBookingSignalRDTO } from "../interfaces/cancel-booking-signalR.interface";
import { SignalREvents } from "../events/signalR.event";
import { DefaultSignalRDTO } from "../interfaces/default-signalR.interface";

@Injectable({ providedIn: 'root' })
export class SignalRHubService {
  
    
public messageReceiver = signal<RtMessage<any> | null>(null);
public bookingStatusChangedSignal = signal<RtMessage<BookingStatusUpdateSignalRDTO> | null>(null);
public newBookingSignal = signal<RtMessage<NewBookingSignalRDTO> | null>(null);
public cancelCustomerBookingSignal = signal<RtMessage<CancelBookingSignalRDTO> | null>(null);
public cancelDriverBookingSignal = signal<RtMessage<CancelBookingSignalRDTO> | null>(null);
public rideBookedSignal = signal<RtMessage<DefaultSignalRDTO> | null>(null);
/** #5: bumps each time the server says the driver's trip categories changed. */
public categoriesChangedSignal = signal(0);
/** #8: bumps when a fleet join request changes (lists and the fleet's badge refresh). */
public fleetJoinRequestChangedSignal = signal(0);
/** #34: bumps when the driver's background check status changes. */
public backgroundCheckChangedSignal = signal(0);

   constructor() {

   effect(() => {
    const msg = this.messageReceiver();
    if (!msg) return;
    console.log('SignalRHubService received message:', msg);
    switch (msg.eventName) {
        case SignalREvents.BOOKINGSTATUSCHANGED:
            this.bookingStatusChangedSignal.set(msg);   
            break;
        case SignalREvents.NEWBOOKING:
            this.newBookingSignal.set(msg);
            break;
        case SignalREvents.CANCELCUSTOMERBOOKING:
            this.cancelCustomerBookingSignal.set(msg);
            break;
        case SignalREvents.CANCELDRIVERBOOKING:
            this.cancelDriverBookingSignal.set(msg);
            break;
        case SignalREvents.RIDEBOOKED:
            this.rideBookedSignal.set(msg);
            break;
        case SignalREvents.CATEGORIESCHANGED:
            this.categoriesChangedSignal.update((n) => n + 1);
            break;
        case SignalREvents.FLEETJOINREQUESTCHANGED:
            this.fleetJoinRequestChangedSignal.update((n) => n + 1);
            break;
        case SignalREvents.BACKGROUNDCHECKCHANGED:
            this.backgroundCheckChangedSignal.update((n) => n + 1);
            break;
    }
    this.messageReceiver.set(null); // reset after handling 
   });

   }
}